// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__lRvLX","productName":"Table_productName__7FMYH"};